export const environment = {
  production: true,
  userauthenticationapi: 'https://userauthassetone.digital.lntecc.com',
  masterapi: 'https://masterassetone.digital.lntecc.com',
  mastermanagement: 'https://mastermgmtassetone.digital.lntecc.com',
  concretechainapi: 'https://concretechainassetone.digital.lntecc.com',
  weighbridgeapi: 'https://weighbridgeassetone.digital.lntecc.com',
  //crusher
  ltccrusherapi: 'https://crusherassetone.digital.lntecc.com',
  
  ltehlogintoken: 'https://userauthassetonelteh.digital.lntecc.com',
  ltclogouttoken: 'https://userauthassetone.digital.lntecc.com',
  ltctoltehurl: 'https://assetonelteh.digital.lntecc.com/login',
  ssourl: 'https://assetone.digital.lntecc.com/',
  ssohosturl: 'assetone.digital.lntecc.com',
  ssoclientid: '0a69a3b2-1953-4ec0-a3b1-e9978a4fdd51',
  Type: 'Web',
  LoginWith: 'DIRECT',
  googleApiKey: 'AIzaSyA8kbmaC-aeFOLu2VQt-niDpiDSqtyYkSw',
  PublicKey: 'Mb1Q6r0knNqGzdSTwcLQMYssmdAnAzDE',
  description: '',
  DeviceId: '',
  statusCode: {
    SUCCESS: 200,
    LOGOUT: 203,
  },
  ReportingColor: '#8aab83',
  NotReportingColor: '#d98f8f',
  WEIGHMENT_TYPE: [
    {
      Id: 'Gross',
      Name: 'Gross',
    },
    {
      Id: 'Tare',
      Name: 'Tare',
    },
    {
      Id: 'Partial',
      Name: 'Partial',
    },
  ],
  FILE_TYPE: 'environment.production-ltc',
};
